import axios, { get, post } from "axios";

export const GET = (url, config) => (config ? get(url, config) : get(url));
export const POST = (url, config) => (config ? post(url, config) : post(url));
